import { useSyncExternalStore } from 'react';

// Si la pantalla es de celular. **El corte es el mismo que el de
// `apps/admin/src/estilos.css`** (767px): si se cambia uno, se cambia el otro, o
// el JS decide «cajón» mientras el CSS dibuja «columna fija».
//
// Hace falta en JS, y no solo en CSS, porque en celular las piezas cambian de
// forma y no solo de tamaño: en el layout aparecen los botones de los cajones y
// los laterales pasan a abrirse y cerrarse, y el `Listado` dibuja tarjetas en
// vez de tabla (#183). Vive aquí, y no en el admin, para que los dos usen el
// mismo corte.
const CONSULTA = '(max-width: 767px)';

function suscribir(avisar: () => void) {
  const medios = window.matchMedia(CONSULTA);
  medios.addEventListener('change', avisar);
  return () => medios.removeEventListener('change', avisar);
}

export function useEsCelular(): boolean {
  return useSyncExternalStore(suscribir, () => window.matchMedia(CONSULTA).matches);
}
